import { render, staticRenderFns } from "./PesquisaAntiga.vue?vue&type=template&id=711bb6f2&"
import script from "./PesquisaAntiga.vue?vue&type=script&lang=js&"
export * from "./PesquisaAntiga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports